import CryptoJS from 'crypto-js';

//********** SECURE KEYS OUR */
 const mySecureKey = "#ManD@ip1996@123#$07";
// Secret key for encryption (should be stored more securely in production)
const encryptionKey = "#$@!26312545)(#@S@^%$";

// Function to generate a unique nonce
const generateNonce = () => {
  const timestamp = Date.now();
  const randomStr = Math.random().toString(36).substring(2, 15);
  return `${timestamp}.${randomStr}`;
};

// Function to encrypt the security key with nonce
export const encryptSecurityKey = () => {
  const nonce = generateNonce();
  // Combine the key with the nonce so each encryption is unique
  const dataToEncrypt = JSON.stringify({
    key: mySecureKey,
    nonce: nonce,
    timestamp: Date.now(),
  });

  // Encrypt the combined data
  const encrypted = CryptoJS.AES.encrypt(
    dataToEncrypt,
    encryptionKey
  ).toString();

  // Return both the encrypted data and the nonce
  return {
    encrypted,
    nonce,
  };
};
